<template>
  <div class="footer">
      <div class="info">
        <div class="linkurl">
          <h5>相关链接：</h5>
          <ul>
            <li v-for="(link) in links" :key="link.id"><a :href="link.url" target="_blank" style="color:#fff">{{link.name}}</a></li>
          </ul>
        </div>
        <div class="cominfo">
          <div class="records">
            <p>主办单位：{{ name }}  </p>
            <p>支持单位：{{ name }} </p>
            <p>技术支持：{{ name }} </p>
            <p>{{ copyright }}  &nbsp;|&nbsp; {{ recodenum }}</p>
            <p>电话：{{ mobile }}  &nbsp;|&nbsp; E-mail：{{ email }}</p>
            <!-- <p>QQ：739436060 | 法律顾问：王蔚律师</p> -->
          </div>
          <div class="qrcode" >
            <img width="135" height="135" src="/static/img/gzh_qrn.png">
          </div>
          <a href="javascript:;">扫码访问</a>
          <div class="qrcode" style="    right: 204px;    top: 27px;">
            <img width="135" height="135"  src="/static/img/gzh_qrn.png">
          </div>
          <a href="javascript:;" style=" right: 203px;">扫码关注</a>
        </div>
        
        <!-- <a href="javascript:;" style="right: 203px;">抖音公众号</a> -->
      </div>
  </div>
</template>

<script>
// import QRCode from 'qrcodejs2'
import { getLiveBlogroll } from '@/request/get'
export default {
  name: "Footer",
  computed: {
    copyright() {
      return this.$store.getters.copyright;
    },
    recodenum() {
      return this.$store.getters.recodenum;
    },
    address() {
      return this.$store.getters.address;
    },
    email() {
      return this.$store.getters.email;
    },
    name() {
      return this.$store.getters.name;
    },
    phone() {
      return this.$store.getters.phone;
    },
    mobile() {
      return this.$store.getters.mobile;
    },
    shortname() {
      return this.$store.getters.shortname;
    },
  },
  data() {
    return {
      links: [],
      members: [],
      separtments: [],
      relatives: [],
      isSelect: 'members'
    }
  },
  mounted() {

    this.getLiveBlogroll();
  },
  methods: {
    changeLink(link) {
      this.isSelect = link;
      this.links = this[link];
    },
    async getLiveBlogroll() {
      let result = await getLiveBlogroll();
      result = result.data;
      if (Array.isArray(result)) {
        result.forEach((item) => {
          if (item.type == "会员单位" || item.type == "友情链接") {
            this.members.push(item);
          } else if (item.type == "部门网站") {
            this.separtments.push(item);
          } else if (item.type == "相关网站") {
            this.relatives.push(item);
          }
        });
        this.links = this.members;
      }
    }
  }
};
</script>
<style scoped>
.footer{
  position: relative;
  margin-top: 24px;
  height: 408px;
  background-image: url(/static/img/footerbg.png);
}
.footer>.info{
  position: relative;
  margin: 0 auto;
  width: 1300px;
}
.footer>.info>.linkurl{
  position: relative;
  width: 1300px;
  height: 130px;
  border-bottom: 1px solid #E7E8E9;
}
.footer>.info>.linkurl>h5{
  position: absolute;
  top:36px;
  left:0;
  height: 14px;
  font-size: 18px;

  font-weight: bold;
  color: #fff;
  line-height: 14px;
}
.footer>.info>.linkurl>ul {
  position: relative;
  top:36px;
  padding-left: 97px;
  height: 130px;
  display: block;
  justify-content: space-between;
  align-items: center;
}

.footer>.info>.linkurl>ul>li {
  position: relative;
  padding-left: 17px;
  height: 18px;
  font-size: 18px;

  font-weight: 500;
  color: #fff;
  line-height: 18px;
      display: inline-block;
    width: 203px;
    overflow: hidden;
    word-break: break-all;
    -webkit-box-orient: vertical;
        white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
-webkit-line-clamp: 1;
  margin-bottom: 14px;
}

.footer>.info>.linkurl>ul>li::before {
  position: absolute;
  top: 4.5px;
  left: 0px;
  content: "";
  width: 5px;
  height: 5px;
  background: #fff;
  border-radius: 50%;
}

.records{
  position: absolute;
  top:29px;
  left: 3px;
  width: 950px;
  height: 160px;
  overflow: hidden;
}
.records>p{
  margin-bottom: 28px;
  height: 18px;
  font-size: 18px;

  font-weight: 500;
  color: #fff;
  line-height: 18px;
}
.qrcode{
  position: absolute;
  top:27px;
  right:17px;
  width: 135px;
  height: 135px;
  background: #FFFFFF;
  display: flex;
  justify-content: center;
  align-items: center;
}
.cominfo{
  position: relative;
}
.cominfo>a{
  position: absolute;
  width: 135px;
  top:169px;
  right: 17px;
  height: 18px;
  font-size: 18px;

  font-weight: 500;
  color: #fff;
  line-height: 18px;
  text-align: center;
  
}
</style>
